"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSignInLink = exports.defaultSignOutLink = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const common_1 = require("@epic-core/common");
const defaultSignOutLink = (locale) => {
    const queryString = (0, epic_games_nav_shared_1.generateStateQueryString)(locale);
    return {
        href: `${(0, common_1.getPath)()}logout${queryString}`
    };
};
exports.defaultSignOutLink = defaultSignOutLink;
const defaultSignInLink = (locale) => {
    const queryString = (0, epic_games_nav_shared_1.generateStateQueryString)(locale);
    return {
        href: `${(0, common_1.getPath)()}login${queryString}`
    };
};
exports.defaultSignInLink = defaultSignInLink;
//# sourceMappingURL=accountDropdownUtils.js.map